import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import template from './AdminCenter.html?raw';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload";
import RegistrationForm from '../RegistrationForm/RegistrationForm';
import { publish } from "dojo/_base/connect";
import "../DoctorListTypes";
import { ToasterHelpers } from "../../../../more/Helpers";

class AdminCenter extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private doctorList: HTMLDivElement;
    private btnSelectAll: HTMLButtonElement;
    private btnDeselectAll: HTMLButtonElement;
    private btnClipboardMail: HTMLButtonElement;
    private btnClipboardMailSelected: HTMLButtonElement;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.loadDoctorList();

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        this.setUrlParameter(DoctorList_UrlParameters.action, "adminCenter");
        //this._checkUrlParameters();
    }

    private _checkUrlParameters(): boolean {
        let action: any = this.getUrlParameterValue(DoctorList_UrlParameters.action);
        let value: any = this.getUrlParameterValue(DoctorList_UrlParameters.adminCenterTarget);
        //console.debug("adminCenter _checkUrlParameters", action, value);
        if (action == "adminCenter") {
            if (value == "list") {
                // nix, mach ma ja eh scho
                return true;
            } else if (value == "create") {
                this._CreateDoctor();
                return true;
            }

            else if(value != false){
                this.openTarget(value);
                return true;
            }

            
        }
        return false;
    }
    private _requestHandle: any = null;
    loadDoctorList(): void {
        let requestUrl = window.appRoot + "doctorlist/GetAllDoctors";

        this.StandbyStart();

        this._requestHandle = this.RequestManager.post(
            requestUrl,
            {},
            lang.hitch(this, this._onLoadDoctorListResponse),
            lang.hitch(this, this._onLoadDoctorListError),
            false // sync
        );
    }

    private stopRequest(): void {
        //console.debug("adminCenter stopRequest", this._requestHandle);
        if (this._requestHandle != null) {
            this._requestHandle.cancel();
        }
    }

    private _table: Tabulator = null;

    private _onLoadDoctorListResponse(response): void {
        //console.log("_onLoadDoctorListResponse", response);

        this.StandbyStop();

        let editHitched = lang.hitch(this, this._editDoctor);
        let selectHitched = lang.hitch(this, this._onDocSelectionChanged);
        let selectCheck = lang.hitch(this, this.tableSelectCheck);

        let table = new Tabulator(this.doctorList, {
            data: response.Arr,
            layout: "fitColumns",//"fitDataStretch",
            //height: "unset",
            //maxHeight: "300", // funzt nicht
            rowClick: editHitched,
            selectable: true,
            selectableCheck: selectCheck,
            //dataFiltering: lang.hitch(this, this._filterList),
            rowSelectionChanged: selectHitched,
            columns: [
                //{ formatter: "rowSelection", title: null, "titleFormatter": "rowSelection", width: 10, headerSort: false },
                { title: this.translations["Doctorlist__Admin_UserList_ColTitle_Name"],/*,"Nachname",*/ field: "last_name", headerSort: true },
                { title: this.translations["Doctorlist__Admin_UserList_ColTitle_Firstname"],/*"Vorname", */field: "first_name", headerSort: true },
                { title: this.translations["Doctorlist__Admin_UserList_ColTitle_Username"],/*"Benutzername", */field: "username", headerSort: true },
                { title: this.translations["Doctorlist__Admin_UserList_ColTitle_Email"],/*"E-Mail", */field: "email", headerSort: true },
                { title: this.translations["Doctorlist__Admin_UserList_ColTitle_NoteSpecialization"],/*"E-Mail", */field: "note", headerSort: false, formatter: "textarea" },

            ],
            rowFormatter: function (row) {
                var data = row.getData();

                

                if (!data.is_active) {
                    let rowNode = row.getElement();
                    rowNode.classList.add("inactive")
                }
            },
        });

        table.setSort("last_name", "asc");

        this._table = table;

        // einmal: ALLE aktiven Einträge fürs Clipboard vorbereiten, dann special speichern
        this._onDocSelectionChanged(this._getActiveData(), null);
        this._clipboardContentAllMails = this._clipboardContent;

        this._onDocSelectionChanged([], null);
        this._clipboardContent = "";

        if (this._checkUrlParameters() == false) {
            this.setUrlParameter(DoctorList_UrlParameters.adminCenterTarget, "list");
        }
    }


    private _onLoadDoctorListError(response): void{
        //console.log(response);
        alert("error loading list:\r\n" + response.Message);

        this.StandbyStop();
    }

    private _getActiveData(): Array<DoctorList.DoctorData>{
        if (!this._table) return [];
        let array = this._table.getData() as Array<DoctorList.DoctorData>;

        return array.filter(entry => entry.is_active == true);
    }

    private _onClick_SelectAll(evt: MouseEvent) {
        let rows = this._table.getRows();

        for (let row of rows) {
            let data = row.getData() as DoctorList.DoctorData;
            if (data.is_active == true) {

                row.select();
            }
        }
    }
    private _onClick_DeselectAll(evt: MouseEvent) {
        let rows = this._table.getRows();

        for (let row of rows) row.deselect();
    }

    private _onDocSelectionChanged(currentSelectionArray: Array<DoctorList.DoctorData>, rows: Array<Tabulator.RowComponent>): void {
        let content = "";

        let bIsSelection = false;
        if (currentSelectionArray && currentSelectionArray.length) {
            for (let item of currentSelectionArray) {
                content += item.email + ";"

                bIsSelection = true;
            }
        }

        //console.debug("_onDocSelectionChanged", data, selection, content);

        this.hideNode(this.btnClipboardMailSelected, !bIsSelection);
        this.hideNode(this.btnClipboardMail, bIsSelection);

        if (this._table) {
            let activeData = this._getActiveData();
            this.hideNode(this.btnSelectAll, false);
            //this.hideNode(this.btnDeselectAll, false);
            this.disableNode(this.btnSelectAll, currentSelectionArray?.length == activeData?.length);
            this.hideNode(this.btnDeselectAll, !bIsSelection);
        }

        this._clipboardContent = content;
    }

    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.warning, timeout: number = 4000) {

        publish("WebCalendar/ShowToast", [text, icon, timeout ]);
    }

    private _clipboardContent: string = "";
    private _clipboardContentAllMails: string = "";

    private _allMailsToClipboard() {
        let content = this._clipboardContentAllMails;

        this._tryCopyMailsToClipboard(content);
    }




    private _onClick_MailClipboard(evt: MouseEvent) {
        evt.stopPropagation();
        let content = this._clipboardContentAllMails;

        this._tryCopyMailsToClipboard(content);
    }
    private _onClick_MailClipboardSelected(evt: MouseEvent) {
        evt.stopPropagation();
        let content = this._clipboardContent;

        if (content == "" || content == null) {

            let dlg = new GenericDialog();
            dlg._setHeaderAttr(this.translations["Doctorlist__Admin_DlgHead_ClipboardMail"]);
            dlg._setContentAttr(this.translations["Doctorlist__Admin_Dlg_ClipboardMail"]);
            dlg._setTopCloseBtnAttr(true);
            dlg._setCloseBtnAttr(true);

            dlg.setUserdefinedButton(this.translations["Doctorlist__Admin_Dlg_ClipboardMail_BtnCopyall"], null, lang.hitch(this, this._allMailsToClipboard), true);

            dlg.closeOnEnter = true;
            dlg.show();

            return;
        }

        this._tryCopyMailsToClipboard(content);
    }

    private _tryCopyMailsToClipboard(content: string) {

        if (!content) return;

        try {
            navigator.clipboard.writeText(content);
            this.publishToastMessage(this.translations["Doctorlist__Admin_Toast_Confirm_ClipboardMailCopied"], ToasterHelpers.ToasterIcons.confirmCheck);

        } catch (errorMsg) {

            let dlg = new GenericDialog();
            dlg._setHeaderAttr(this.translations["Doctorlist__Admin_DlgHead_ClipboardMail"]);
            dlg._setTextIconAttr("fas fa-exclamation-triangle");
            if (window.isSecureContext) {

            } else {

            }

            dlg._setContentAttr(this.translations["Doctorlist__Admin_Dlg_ClipboardCannotBeAccessed"]);
            if (this.hasUserRole("_DEV")) dlg._setSubTitleAttr(errorMsg, true)
            dlg._setTopCloseBtnAttr(true);
            dlg._setCloseBtnAttr(true);

            dlg.closeOnEnter = true;
            dlg.show();

        }
        //this.UiModder.domClass.remove(this.btnClipboardMail, "w3-hide");

    }

    private tableSelectCheck(row) {
        let data = row.getData() as DoctorList.DoctorData;
        //console.debug("tableSelectCheck", row, data);
        return data.is_active;
    }

    reload(): void {
        this.setUrlParameter(DoctorList_UrlParameters.adminCenterTarget, "list");
        this.UiModder.domConstruct.empty(this.doctorList);
        //this.UiModder.domAttr.set(this.doctorList, "innerHTML", "");
        this.loadDoctorList();
    }

    private _onRegisterFormDirty(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof RegistrationForm>>, state: boolean) {

        //console.debug("AdminCenter _addSaveButtonToEditDlg", state, typeof(dlg), typeof(form));

        dlg.enableButton("save", state);
    }

    openTarget(userID: string) {
        if (userID == null || userID == "") {
            return;
        }
        if (this._table) {
            //console.debug("adminCenter openTarget", this._table.getRows());
            for (let row of this._table.getRows()) {
                //console.debug("adminCenter openTarget", row.getData());
                if (row.getData().WebUserId == userID) {
                    this._editDoctor(null, row);
                    return;
                }
            }
        }

        // urlparameter zurücksetzen?
        this.setUrlParameter(DoctorList_UrlParameters.adminCenterTarget, "list");
    }

    private _editDoctor(evt: MouseEvent, row: any): void{
        if (evt) {
            if (evt.shiftKey || evt.ctrlKey) {
                return;
            }

            evt.stopPropagation();
        }

        row.getTable().deselectRow();
        //console.debug("_editDoctor", row);
        
        let rowData = row.getData();
        //console.debug(rowData);

        this.setUrlParameter(DoctorList_UrlParameters.adminCenterTarget, rowData.WebUserId);

        let dlg = new GenericDialog();
        dlg.propagateClick = false;
        dlg._setTopCloseBtnAttr(true);

        dlg.on("closed", lang.hitch(this, function () { this.setUrlParameter(DoctorList_UrlParameters.adminCenterTarget, "list"); }));


        if (rowData.is_active) {
            let form = new RegistrationForm();
            form.startup();

            form.callback = lang.hitch(this, this.reload);
            
            dlg.closeOnEnter = false;
            dlg.keepOpen = true;

            dlg.show(form,
                this.translate("Doctorlist__Admin_EditUserDlg_Header"),
                null,
                null,
                "saveclose",
                lang.hitch(this, this._onEditDlgResult, dlg, form));

            dlg.disableButton("save");

            form.parentDialog = dlg;
            form.setData(rowData, false, "showButton", true);

            on(form, "dirty", lang.hitch(this, this._onRegisterFormDirty, dlg, form));

        }
        else {

            let form = new RegistrationForm();
            form.startup();
            form.setData(rowData, true, false);


            dlg.show("",
                this.translate("Doctorlist__Admin_ActivationDlg_Header"),
                null,
                null,
                "close"
            );


            dlg._setContentAttr(this.stringFormat(this.translate("Doctorlist__Admin_ActivationDlg_InactiveNote"), rowData.username));
            dlg.addNodeToContent(form.domNode);

        }
    }

    private _onEditDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof RegistrationForm>>, result: number) {
        if (result >= 1) {
            dlg.disableButton("save");
            form.saveEdit();
        } else {
            dlg.close(-1, true);
        }
    }

    private _ActivateDoctor(ID: string, dlg): void {

        var requestUrl = window.appRoot + "doctorlist/ActivateDoctor";

        this.RequestManager.post(
            requestUrl,
            {
                "DoctorID": ID
            },
            lang.hitch(this, this._onActivateDoctor_Response, dlg),
            lang.hitch(this, this._onActivateDoctor_Error, dlg),
            false // sync
        );

        this.reload();
    }

    private _onActivateDoctor_Response(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response: any) {
        if (dlg) {
            dlg.close(-1, true);
        }

        this.reload();
    }

    private _onActivateDoctor_Error(error: any) {

        this.reload();
    }


    _onClick_NewDoctor(evt: MouseEvent): void {
        evt.stopPropagation();
        this._CreateDoctor();
    }

    private _CreateDoctor(): void {
        var resetHitched = lang.hitch(this, this.reload);

        this.setUrlParameter(DoctorList_UrlParameters.adminCenterTarget, "create");

        var form = new RegistrationForm();
        form.startup();

        form.callback = resetHitched;

        var dlg = new GenericDialog();
        //this.UiModder.domClass.replace(dlg.headerBarNode, "secondaryBG", "accentBG");
        dlg.set("header", this.translations["Doctorlist__Admin_CreateUserDlg_Header"]);//"Neuen User Erstellen");
        dlg.addNodeToContent(form.domNode);

        // verhindern dass ENTER den Dialog schließt!!
        dlg.closeOnEnter = false;
        dlg.propagateClick = false;
        dlg._setTopCloseBtnAttr(true);
        dlg._setCallbackAttr(lang.hitch(this, this.setUrlParameter, DoctorList_UrlParameters.adminCenterTarget, "list"))
        //dlg._setCancelBtnAttr(true);

        //console.log("dlg close?", dlg.closeOnEnter);

        dlg.show();
        form.parentDialog = dlg;
    }

}

export default mdsWidget(AdminCenter);